import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 56 56"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g stroke=\"currentColor\" stroke-width=\"3\" clip-path=\"url(#i-1238484354__a)\"><path d=\"M28 40.25a.875.875 0 0 1 0-1.75M28 40.25a.875.875 0 0 0 0-1.75\"></path><path stroke-linecap=\"round\" stroke-miterlimit=\"10\" d=\"M28 31.5V12.25\"></path><path stroke-miterlimit=\"10\" d=\"M28 54.25c14.498 0 26.25-11.752 26.25-26.25S42.498 1.75 28 1.75 1.75 13.503 1.75 28 13.503 54.25 28 54.25Z\"></path></g><defs><clipPath id=\"i-1238484354__a\"><path fill=\"#fff\" d=\"M0 0h56v56H0z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }